import React from 'react';

interface VoiceChatControlsProps {
  connected: boolean;
  connecting: boolean;
  isPaused?: boolean;
  isResumedSession?: boolean;
  onStart: () => void;
  onPauseResume: () => void;
}

const VoiceChatControls: React.FC<VoiceChatControlsProps> = ({
  connected,
  connecting,
  isPaused,
  isResumedSession,
  onStart,
  onPauseResume
}) => (
  <>
    {!connected ? (
      <button
        onClick={onStart}
        disabled={connecting}
        style={{
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingTop: '13px',
          paddingBottom: '13px',
          background: connecting ? '#063247' : '#042434',
          borderRadius: '100px',
          color: 'white',
          fontSize: '16px',
          fontFamily: 'Lato',
          fontWeight: '700',
          wordWrap: 'break-word',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '4px',
          flexWrap: 'wrap',
          alignContent: 'center',
          opacity: connecting ? 0.8 : 1,
          cursor: connecting ? 'not-allowed' : 'pointer',
          minWidth: '200px'
        }}
        onMouseEnter={(e) => {
          if (!connecting) {
            e.currentTarget.style.background = '#063247';
          }
        }}
        onMouseLeave={(e) => {
          if (!connecting) {
            e.currentTarget.style.background = '#042434';
          }
        }}
      >
        <img 
          src="/Icon/Mic.svg" 
          alt="Microphone" 
          style={{ width: '20px', height: '20px' }}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.onerror = null;
            // Fallback to inline SVG if image fails
            target.style.display = 'none';
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', '20');
            svg.setAttribute('height', '20');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('fill', 'white');
            svg.innerHTML = '<path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/><path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>';
            target.parentNode?.appendChild(svg);
          }}
        />
        {connecting ? 'Connecting…' : isResumedSession ? 'Continue Conversation' : 'Start Voice Chat'}
      </button>
    ) : (
      <button
        onClick={onPauseResume}
        style={{
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingTop: '13px',
          paddingBottom: '13px',
          background: '#042434',
          borderRadius: '100px',
          color: 'white',
          fontSize: '16px',
          fontFamily: 'Lato',
          fontWeight: '700',
          wordWrap: 'break-word',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '4px',
          flexWrap: 'wrap',
          alignContent: 'center',
          minWidth: '200px'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#063247'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#042434'}
      >
        {isPaused ? (
          <>
            <div style={{ width: '0', height: '0', borderLeft: '10px solid white', borderTop: '6px solid transparent', borderBottom: '6px solid transparent' }}></div>
            Resume
          </>
        ) : (
          <>
            <div style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
              <div style={{ width: '4px', height: '14px', backgroundColor: 'white', borderRadius: '1px' }}></div>
              <div style={{ width: '4px', height: '14px', backgroundColor: 'white', borderRadius: '1px' }}></div>
            </div>
            Pause
          </>
        )}
      </button>
    )}
  </>
);

export default VoiceChatControls;
